// Testimonials.jsx
import React from "react";
import "../style/Testimonials.scss";
import testimonialsData from "../data/testimonials.json"; // import JSON

const Testimonials = () => {
  return (
    <section className="testimonials">
      <h2 className="title-testimonials">Testimonials</h2>
      <p className="subtitle-testimonials">
        Hear From Our Satisfied Clients. Our Testimonials Showcase The Positive
        Impact Our Work Has Had On Businesses, Highlighting The Exceptional
        Service, Creativity, And Results We Bring To Every Project.
      </p>

      <div className="cards-testimonials">
        {testimonialsData.map((testimonial, index) => (
          <div className="card-testimonials" key={index}>
            <p className="quote-testimonials">"{testimonial.quote}"</p>
            <img
              src={testimonial.logo}
              alt={testimonial.alt}
              className="logo-testimonials"
            />
          </div>
        ))}
      </div>
    </section>
  );
};

export default Testimonials;